import React from 'react'
const SubAbout = () => {
    return (

        <div className="aboutAll">
            
            <div className="about_content ">
                <h2>I'm Osama Megahed</h2>
                <p>
                    I'm a student at AAST, I study Engineering, Electronics and communication
                    department , it's the second year to me at the college. I was so interested
                    about web development specially the front-end career so I started to learn
                    it for over than a year and I have accomplished many websites which are real
                    and virtual and I am so excited to start work with you
                </p>
                <div className="social_links">
                    <h6 className='mb-3'>Connect with me:</h6>
                    <span><a href="https://github.com/osama24680"><i className="ri-github-line" /></a></span>
                    <span><a href="https://www.linkedin.com/in/osama-meaghed-58763022a/"><i className="ri-linkedin-line" /></a></span>
                    <span><a href="https://www.facebook.com/profile.php?id=100010179812706"><i className="ri-facebook-line" /></a></span>
                    <span><a href="https://www.instagram.com/osamamegahed123/"><i className="ri-instagram-line" /></a></span>
                    
                </div>
            </div>
        </div>

    )
}

export default SubAbout
